import { render } from "./TopUserProfile.vue?vue&type=template&id=2578c10a"
import script from "./TopUserProfile.vue?vue&type=script&lang=js"
export * from "./TopUserProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__